import React, { ReactElement, useState } from 'react';
import { InputField, InputType } from './InputField';
import { passwordStrength } from 'check-password-strength';
import SuccessIcon from '../assets/success-green.png';
import ErrorIcon from '../assets/error-red.png';

/* eslint-disable-next-line */
interface Props {
  type?: InputType;
  style?: React.CSSProperties;
  visible?: boolean;
  renderIcon?: boolean;
  onWatchPassword?: () => void;
  value?: string;
  required?: boolean;
  placeholder?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>, strength?: number, pointsCheckFail?: boolean) => void;
  lock?: boolean;
  strengthCheck?: boolean;
  iconStyle?: React.CSSProperties;
  isResetModal?: boolean;
}

interface PasswordErrorObjI {
  success: boolean;
  message: string;
  value?: string;
}

const passwordErrorObjData: PasswordErrorObjI[] = [
  {
    success: false,
    message: 'Password needs to be more than 8 character',
  },
  {
    success: false,
    message: 'Password must contains numbers',
  },
  {
    success: false,
    message: 'Password must contains uppercase letters',
  },
  {
    success: false,
    message: 'Password must contains lowercase letters',
  },
  // {
  //   success: false,
  //   message: 'Password must contains special characters',
  // },
];

export default function PasswordField(props: Props): ReactElement {
  const [passStrengthCheck, setPassStrengthCheck] = useState<number>(0);
  const [passwordErrorObj] = useState<PasswordErrorObjI[]>(passwordErrorObjData);
  const [showStrengthText, setShowStrengthText] = useState<boolean>(true);
  const onPasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (props.strengthCheck) {
      let passwordAbility = 0;
      let pointsCheckFail = false;
      const strength = passwordStrength(e.target.value);
      if (!e.target.value.length) {
        setPassStrengthCheck(0);
      } else {
        // if (strength.value === 'Too weak') {
        //   setPassStrengthCheck(1);
        //   passwordAbility = 1;
        // } else if (strength.value === 'Weak') {
        //   setPassStrengthCheck(2);
        //   passwordAbility = 2;
        // } else if (strength.value === 'Strong') {
        //   setPassStrengthCheck(3);
        //   passwordAbility = 3;
        // } else {
        //   // setPassStrengthCheck(0);
        // }

        /* eslint-disable-next-line */
        const spacialCharRegex = /[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
        const upperCaseWordRegex = /[A-Z]/;
        const lowerCaseWordRegex = /[a-z]/;

        const passwordHintData: PasswordErrorObjI[] = [...passwordErrorObj];

        if (e.target.value.length >= 8) {
          passwordHintData[0].success = true;
        } else {
          passwordHintData[0].success = false;
        }
        if (e.target.value.match(/\d+/)) {
          passwordHintData[1].success = true;
        } else {
          passwordHintData[1].success = false;
        }

        if (upperCaseWordRegex.test(e.target.value)) {
          passwordHintData[2].success = true;
        } else {
          passwordHintData[2].success = false;
        }

        if (lowerCaseWordRegex.test(e.target.value)) {
          passwordHintData[3].success = true;
        } else {
          passwordHintData[3].success = false;
        }

        // if (spacialCharRegex.test(e.target.value)) {
        //   passwordHintData[4].success = true;
        // } else {
        //   passwordHintData[4].success = false;
        // }

        let success = true;
        let successCount = 0;
        passwordHintData?.map((itm) => {
          if (!itm.success) {
            success = false;
          } else {
            successCount = successCount + 1;
          }
          return itm;
        });

        if (successCount === 4) {
          setPassStrengthCheck(3);
          passwordAbility = 3;
        } else if (successCount === 3) {
          setPassStrengthCheck(2);
          passwordAbility = 2;
        } else {
          setPassStrengthCheck(1);
          passwordAbility = 1;
        }
        // console.log('passwordHintData', passwordHintData);

        if (success) {
          setShowStrengthText(false);
          pointsCheckFail = false;
        } else {
          setShowStrengthText(true);
          pointsCheckFail = true;
        }
      }

      props.onChange(e, passwordAbility, pointsCheckFail);
    } else {
      props.onChange(e);
    }
  };

  return (
    <div>
      <InputField
        value={props.value}
        onChange={(e) => {
          onPasswordChange(e);
        }}
        type="password"
        renderIcon={true}
        lock={props.lock}
        placeholder={props.placeholder}
        iconStyle={{
          marginRight: props.isResetModal ? '30px' : '14px',
          ...props.iconStyle,
        }}
      />

      {props.strengthCheck ? (
        passStrengthCheck > 0 ? (
          <React.Fragment>
            <div className="password-strength-container">
              <span
                className={
                  passStrengthCheck >= 3
                    ? 'green'
                    : passStrengthCheck >= 2
                    ? 'orange'
                    : passStrengthCheck >= 1
                    ? 'red'
                    : 'week'
                }
              ></span>
              <span className={passStrengthCheck >= 3 ? 'green' : passStrengthCheck >= 2 ? 'orange' : 'medium'}></span>
              <span className={passStrengthCheck >= 3 ? 'green' : 'strong'}></span>
            </div>
            {showStrengthText ? (
              <div className="password-strength-text">
                {passStrengthCheck === 3
                  ? null
                  : passwordErrorObjData?.map((itm, i) => {
                      return (
                        <div key={i}>
                          <img
                            src={itm.success ? SuccessIcon : ErrorIcon}
                            height="20px"
                            width="20px"
                            alt={itm.success ? 'success' : 'error'}
                            style={{ paddingRight: '1px' }}
                          />
                          <p style={{ textAlign: 'left' }}>{itm.message}</p>
                        </div>
                      );
                    })}
              </div>
            ) : null}
          </React.Fragment>
        ) : null
      ) : null}
    </div>
  );
}
